import { firework } from './firework';
import { sideCanon } from './sideCanon';
import { starExplostion } from './starExplostion';
import { tengonfetti } from './tengonfetti';
import { wheel } from './wheel';

type ConfettiType =
  | 'sideCanon'
  | 'starExplosion'
  | 'tengonfetti'
  | 'wheel'
  | 'firework';

type LaunchConfettiProps = {
  duration?: number;
  type?: ConfettiType;
};

export function launchConfetti({ duration = 5000, type }: LaunchConfettiProps) {
  const confettiFn = confettiFactory();

  // trigger a random confetti
  const confettiType =
    type ||
    Array.from(confettiFn.entries())[
      Math.floor(Math.random() * confettiFn.size)
    ][0];

  if (confettiFn.has(confettiType)) {
    confettiFn.get(confettiType)?.(duration);
  }
}

const confettiFactory = (): Map<ConfettiType, (duration?: number) => void> => {
  return new Map<ConfettiType, (duration?: number) => void>([
    ['sideCanon', sideCanon],
    ['starExplosion', starExplostion],
    ['tengonfetti', tengonfetti],
    ['wheel', wheel],
    ['firework', firework],
  ]);
};
